import fetchChatRoom from './fetchChatRoom';
import fetchChatRoomMessage from './fetchChatRoomMessage';

export default {
  fetchChatRoom,
  fetchChatRoomMessage,
};
